import React from "react";
import { Link } from "react-router-dom";

import "./cookie_policy_page.css";

import TermlyPolicyEmbed from "../components/TermlyPolicyEmbed";
import Logo from "../assets/composiq-mark-128.png";

const TERMLY_COOKIE_POLICY_ID = "b697e7b9-7d04-4ba0-8ea3-824480d35a12";

export default function CookiePolicyPage(){
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <div className="App">
      {/* ───────── HEADER (match Home) ───────── */}
      <header className="dbx-header" role="banner">
        <div className="dbx-header-inner">
          <Link to="/" className="dbx-brand" aria-label="Zerivo home">
            <img className="dbx-brand-mark" src={Logo} alt="" />
            <div className="dbx-brand-text-group">
              <span className="dbx-brand-text">Zerivo</span>
              <span className="dbx-brand-subtitle">Private AI</span>
            </div>
          </Link>

          <nav className="dbx-header-nav" aria-label="Main navigation">
            <Link to="/our-team">Our Team</Link>
            <Link to="/contact">Contact</Link>
          </nav>

        </div>
      </header>

      {mobileOpen && (
        <nav className="dbx-mobile-nav" role="navigation" aria-label="Mobile navigation">
          <button className="dbx-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">×</button>
          <Link to="/our-team" onClick={() => setMobileOpen(false)}>Our Team</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link>
          <Link to="/privacy" onClick={() => setMobileOpen(false)}>Privacy</Link>
          <Link to="/terms" onClick={() => setMobileOpen(false)}>Terms</Link>
        </nav>
      )}
      {mobileOpen && <div className="dbx-mobile-backdrop" onClick={() => setMobileOpen(false)} aria-hidden="true"></div>}

      {/* ───────── MAIN CONTENT ───────── */}
      <main className="cookie-wrapper">
        <h1 className="cookie-title">Cookie Policy</h1>
        <p className="cookie-intro">
          This Cookie Policy explains how we use cookies and similar technologies to
          provide, protect, and improve our services.
        </p>

        <TermlyPolicyEmbed
          policyId={TERMLY_COOKIE_POLICY_ID}
          policyName="cookie policy"
        />
      </main>
    </div>
  );
}
